import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { UserDTO } from '../models/user-dto';
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient) {}

  createAccount(dto: UserDTO): Observable<any> {
    return this.http.post(environment.baseUrl + '/inregistrare', dto);
  }

  sendOTP(dto: UserDTO): Observable<any> {
    return this.http.post(environment.baseUrl + '/trimitere-cod-otp', dto);
  }

  sendServiceDeskMailMessage(serviceDeskMailMessage: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/trimitere-mail-service-desk', serviceDeskMailMessage);
  }

  resendOTP(dto: UserDTO): Observable<any> {
    return this.http.post(environment.baseUrl + '/retrimitere-cod-otp', dto);
  }

  checkOTP(dto: UserDTO): Observable<any> {
    return this.http.post(environment.baseUrl + '/verificare-cod-otp', dto);
  }
}
